import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import LastPageIcon from '@mui/icons-material/LastPage'
import { Button, ButtonGroup, SxProps } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'

interface Props {
  minPage: number
  maxPage: number
  hideIfSinglePage?: boolean
  canGoBack: boolean
  canGoForward: boolean
  setPage: Dispatch<SetStateAction<number>>
  sx?: SxProps
}

export const PaginationControls = ({
  minPage,
  maxPage,
  hideIfSinglePage = false,
  canGoBack,
  canGoForward,
  setPage,
  sx,
}: Props) => {
  const goToPreviousPage = () => setPage((current) => Math.max(current - 1, minPage))
  const goToNextPage = () => setPage((current) => Math.min(current + 1, maxPage))
  const goToFirstPage = () => setPage(minPage)
  const goToLastPage = () => setPage(maxPage)
  if (hideIfSinglePage && maxPage === minPage) return null

  const baseStyleProps = {
    size: 'small' as const,
    color: 'secondary' as const,
    sx: { borderRadius: 1.5 },
  }

  return (
    <ButtonGroup color="secondary" sx={sx}>
      <Button aria-label="first page" disabled={!canGoBack} onClick={goToFirstPage} {...baseStyleProps}>
        <FirstPageIcon />
      </Button>
      <Button aria-label="previous page" disabled={!canGoBack} onClick={goToPreviousPage} {...baseStyleProps}>
        <ChevronLeftIcon />
      </Button>
      <Button aria-label="next page" disabled={!canGoForward} onClick={goToNextPage} {...baseStyleProps}>
        <ChevronRightIcon />
      </Button>
      <Button aria-label="last page" disabled={!canGoForward} onClick={goToLastPage} {...baseStyleProps}>
        <LastPageIcon />
      </Button>
    </ButtonGroup>
  )
}
